import { render, staticRenderFns } from "./PdfDocumentFilePreview.vue?vue&type=template&id=4455dd0e"
import script from "./PdfDocumentFilePreview.vue?vue&type=script&lang=js"
export * from "./PdfDocumentFilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports